"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on 28.05.2019
*/

var immutable_1 = require("immutable");

var CodebookItem_1 = require("../../core/model/codebook/CodebookItem");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");
/**
 * Represents types for space planning placement type.
 * U | null -> Standard aisle
 * E -> Headboard
 * P -> Palette
 * S -> Slim
 * C -> Cabinet or other chilled space
 * B -> Tub
 * K -> Basket or quarter palette
 *
 * @author ZSr
 */


var PlacementTypes =
/*#__PURE__*/
function (_CodebookItem_1$Codeb) {
  _inherits(PlacementTypes, _CodebookItem_1$Codeb);

  /**
   * @param id
   * @param title the title of the format
   * @param externalId correspond with logio logic
   */
  function PlacementTypes(id, title) {
    var _this;

    var externalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, PlacementTypes);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlacementTypes).call(this, id, title, null, immutable_1.List(), externalId));
    _this.id = id;
    _this.title = title;
    _this.externalId = externalId;
    return _this;
  }

  return PlacementTypes;
}(CodebookItem_1.CodebookItem);

exports.PlacementTypes = PlacementTypes;
/** Name of code book for generic code book API. */

PlacementTypes.CODEBOOK_NAME = 'placement.types';

PlacementTypes.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CodebookItem_1.CodebookItem.name);
  return {
    id: builder.id('id'),
    title: builder.str('title'),
    description: builder.opt(builder.str('description')),
    flags: builder.listOf(builder.str('flags')),
    externalId: builder.opt(builder.str('externalId'))
  };
}();